import React, { memo, SVGProps } from 'react'

export const Dashboard = memo((props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M17.2435 3.14401H6.75649C4.76641 3.14401 3.14497 4.76449 3.14401 6.75553V17.2435C3.14401 19.2355 4.76449 20.856 6.75649 20.856H17.2435C19.2355 20.856 20.856 19.2355 20.856 17.2435V6.75649C20.856 4.76449 19.2355 3.14401 17.2435 3.14401ZM12.721 8.54497H19.416V10.2365H12.721V8.54497ZM6.75649 4.58401H17.2435C18.4416 4.58401 19.416 5.55841 19.416 6.75649V7.10497H4.58401V6.75553C4.58401 5.55841 5.55937 4.58401 6.75649 4.58401ZM4.58401 17.2435V8.54497H11.281V19.4151H6.75649C5.55841 19.4151 4.58401 18.4416 4.58401 17.2435ZM17.2435 19.416H12.721V11.6765H19.416V17.2435C19.416 18.4416 18.4416 19.416 17.2435 19.416Z"
      fill="currentColor"
    />
  </svg>
))
